/**
 * One CRM write from an admin page (A7Y-4983).
 *
 * Every write reloads every CRM read on success, so the scoreboard, the account
 * page and the this-week view never show a value the API has moved past. A
 * write the API refuses as stale (409 `CRM_CONFLICT`) reloads them too; the
 * form that issued it keeps its own state, so the user's unsaved text survives
 * the reload and can be saved again against the fresh record.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isCrmConflictError } from './crmErrors';

export const CRM_QUERY_ROOT = ['crm'] as const;

export function useCrmWrite<TVars, TResult>(
  write: (vars: TVars) => Promise<TResult>,
  onDone?: (result: TResult) => void
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: write,
    onSuccess: async (result) => {
      await queryClient.invalidateQueries({ queryKey: CRM_QUERY_ROOT });
      onDone?.(result);
    },
    onError: async (err) => {
      if (isCrmConflictError(err)) await queryClient.invalidateQueries({ queryKey: CRM_QUERY_ROOT });
    },
  });
}
